import { getOpxHostApi } from 'owa-opx';

/**
 * Return the scenario data sent from the OPX host app.
 * @returns ScenarioData
 */
export const getScenarioData = async <T>(): Promise<T> => {
    const opxHostApi = getOpxHostApi();
    const scenarioData = await opxHostApi?.getScenarioData<T>();

    return scenarioData;
};
